export default __webpack_public_path__ + "static/media/adaobi.de3834ce.jpg";